import { render, staticRenderFns } from "./ImportAudienceModal.vue?vue&type=template&id=2ba24ea6&scoped=true"
import script from "./ImportAudienceModal.vue?vue&type=script&lang=js"
export * from "./ImportAudienceModal.vue?vue&type=script&lang=js"
import style0 from "./ImportAudienceModal.vue?vue&type=style&index=0&id=2ba24ea6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba24ea6",
  null
  
)

export default component.exports